import { ErrorCallbackFunction, postText } from "../ChoiceApi";
import { AppScreenNames } from '../../Enums/ChoiceEnums';
import { isString } from 'lodash';

export const legacy = {
    // Call the legacy SOAP endpoint and return XML
    async initialize(screenName: AppScreenNames, screenMethod: string, screenInputXml?: string, errorCallback?: ErrorCallbackFunction): Promise<Document|undefined>
    {
        const soapResp = await postText("api/Rinse/iSalusWindowService/Initialize", 
        {
            screen_name: screenName,
            screen_method: screenMethod,
            screen_input: screenInputXml
        }, errorCallback);

        if (!soapResp || "" == soapResp)
            return;

        const xmlResp = (new DOMParser()).parseFromString(soapResp, "text/xml");
        return xmlResp;
    },

    // Convert the XML response to an error message if it exists
    soapErrorMsg(soapResp?: string|Document, soapErrorCallback?:(errorMsg?: string) => void) : string|undefined
    {
        if (!soapResp)
            return;

        if (isString(soapResp))
            soapResp = (new DOMParser()).parseFromString(soapResp, "text/xml");

        const errCode = soapResp.querySelector("error > code");
        if ("1" !== errCode?.innerHTML)
            return;
    
        const errMsg = soapResp.querySelector("error > description")?.innerHTML;

        if (errMsg)
        {
            if (soapErrorCallback)
                soapErrorCallback(errMsg);
            else
                alert(errMsg)
        }
        return errMsg;
    }
};
